import React, {
    useEffect,
    useState
} from 'react';
import {useTranslation} from "react-i18next";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Dialog from "@material-ui/core/Dialog";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import CloseIcon from '@material-ui/icons/Close';
import Slide from "@material-ui/core/Slide";
import ParkingPermitRepository from "../../../repositories/ParkingPermitRepository";
import Grid from "@material-ui/core/Grid";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import {getWeekdayLabelById} from '../../../data/data';

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: 'relative',
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  }
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const ParkingPermitDetailsView = ({id, onClose}) => {

	const {t}  = useTranslation();
    const classes = useStyles();
	const repository = new ParkingPermitRepository();
	const [data, setData] = useState(null);

    useEffect(async () => {
        try {
            const rs = await repository.getById(id);
            setData(rs.data);
        } catch (e) {
            handleClose();
        }

    }, [id]);

    const handleClose = () => {
         if (onClose) {
             onClose();
         }
    }

    const triggerClose = ()  => {
        handleClose();
    }

	return (
	    <>
           <Dialog fullWidth={true} maxWidth={"lg"} open={true} onClose={handleClose} TransitionComponent={Transition}>
            <AppBar className={classes.appBar}>
              <Toolbar>
                <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
                  <CloseIcon />
                </IconButton>
                <Typography variant="h6" className={classes.title}>
                    {t('Parking permit')}
                </Typography>
              </Toolbar>
            </AppBar>
               {data && <Grid container>
                   <Grid item xl={4} xs={12}>
                       <Table className="condensedList">
                            <TableHead>
                                <TableRow>
                                    <TableCell>{t('Weekday')}</TableCell>
                                    <TableCell>{t('Time')}</TableCell>
                                </TableRow>
                            </TableHead>
                           <TableBody>
                           {data.Restrictions.map((restriction, key) => {
                               return (
                                   <TableRow key={key}>
                                        <TableCell>{getWeekdayLabelById(restriction.Weekday)}</TableCell>
                                        <TableCell>{restriction.TimeFrom} - {restriction.TimeTo}</TableCell>
                                   </TableRow>
                               );
                           })}
                           </TableBody>
                       </Table>
                   </Grid>
               </Grid>}
          </Dialog>
      </>
	);
};

export default ParkingPermitDetailsView;